import styled from "styled-components";
import {down} from "../Styles/media";

const Page = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: transparent;
`

const Page__Holder = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1 0 auto;
    padding-top: ${({theme}) => theme.header.height}px;

    ${down('md')} {
        padding-top: ${({theme}) => theme.header.heightMobile}px;
    }
`

const Hidden__Seo__Image = styled.img`
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
    z-index: -1;
`

export const Styled = {
    Page,
    Page__Holder,
    Hidden__Seo__Image
}
